<template>
  <b-container id="body-container" style="padding: 0px" fluid>
    <b-row class="justify-content-center mb-2">
      <b-col cols="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="3" md="8">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h5>
                Over the last 2 years after looking at Millions of Company and
                Billions of Data points we can confidently present you with. The
                top 5 Fastest {Department} employees in the {location} Area.
                What's really amazing has been the variety of data we have
                collected. People from every industry have been coming to
                {location} and the growth over the last 2 years is massive.
                Below you can see companies like {Company Name#1} and {Company
                Name#2}, really explode in the onboarding and lead the pack of
                the entire area.
              </h5>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10" md="10">
        <img src="../../assets/solar-employment-growth.png" />
      </b-col>

      <b-col cols="10">
        <b-col cols="12" md="12">
          <b-row align-h="start" align-v="center" class="header-text-container">
            <b-table class="fast-table" striped show-empty :items="items">
            </b-table>
          </b-row>
        </b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass
</style>

<style lang="sass">
@import @/sass/_colors.sass

.fast-table
  border-radius: 8px
  overflow: hidden
  box-shadow: 0 0px 40px 0px rgba(0, 0, 0, 0.15)
  -moz-box-shadow: 0 0px 40px 0px rgba(0, 0, 0, 0.15)
  -webkit-box-shadow: 0 0px 40px 0px rgba(0, 0, 0, 0.15)
  -o-box-shadow: 0 0px 40px 0px rgba(0, 0, 0, 0.15)
  -ms-box-shadow: 0 0px 40px 0px rgba(0, 0, 0, 0.15)

  td
    font-size: 16px
    line-height: 1.4


  th
    font-size: 16px
    color: #fff
    line-height: 1.4
    background-color: $purple-ligth-2
</style>

<script>
// components
// import MainCard from '@/components/mainCardHome'
// import ourFleet from '@/components/ourFleetCard'
// import ourFleetOG from '@/components/ourFleetCardOriginal'
// import HostCard from '@/components/hostCard'
import VueScrollTo from "vue-scrollto";
import Chart from "highcharts-vue";

// data
// import { guests, yourHosts } from '@/data/masters-of-marketing.js'

export default {
  name: "Body",
  components: {
    //MainCard,
    // ourFleet,
    //ourFleetOG,
    // HostCard
    highcharts: Chart,
  },
  data: function() {
    return {
      id: "",
      issuedBy: "",
      issuedTo: "",
      chartOptions: {
        title: {
          text: "Solar Employment Growth by Sector, 2010-2016",
        },

        subtitle: {
          text: "Source: thesolarfoundation.com",
        },

        yAxis: {
          title: {
            text: "Number of Employees",
          },
        },

        xAxis: {
          accessibility: {
            rangeDescription: "Range: 2010 to 2017",
          },
        },

        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },

        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
            pointStart: 2010,
          },
        },

        series: [
          {
            name: "Installation",
            data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175],
          },
          {
            name: "Manufacturing",
            data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434],
          },
          {
            name: "Sales & Distribution",
            data: [11744, 17722, 16005, 19771, 20185, 24377, 32147, 39387],
          },
          {
            name: "Project Development",
            data: [null, null, 7988, 12169, 15112, 22452, 34400, 34227],
          },
          {
            name: "Other",
            data: [12908, 5948, 8105, 11248, 8989, 11816, 18274, 18111],
          },
        ],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      },
      items: [
        {
          rank: 1,
          company: "Gravity",
          industry: "internet",
          funding: "$410k",
          employees: "12",
          employeeGrowth: "10%",
          jobLinks: "https://linkedin.com/in/bryancolligan",
        },
        {
          rank: 2,
          company: "Salesfood",
          industry: "food",
          funding: "$1.41m",
          employees: "22",
          employeeGrowth: "8%",
          jobLinks: "https://linkedin.com/in/bryancolligan",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    document.head.appendChild(externalScript);
  },
  created() {},
  methods: {
    scrollFix: function(hash) {
      console.log("Scroll To");
      VueScrollTo.scrollTo(hash, 3000);
    },
  },
};
</script>
